/*
  Stoff und Stahl — „Problem melden" an jeder Fehlermeldung (Felix, 20.10.2026).

  Jede Fehlermeldung im Shop bekommt darunter einen Knopf. Ein Druck schickt
  eine Telegram-Nachricht an Felix, mit Seite, Geraet und Fehlerart.

  Was mitgeht: Adresse der Seite (ohne Abfrageparameter), Geraet, Browser und
  der Text UNSERER Fehlermeldung, gekuerzt.
  Was NICHT mitgeht: kein Name, keine Mailadresse, kein Foto, kein Infotext.
  Die Mailadresse wird zusaetzlich aus dem Text entfernt, falls eine Meldung
  sie je zitiert.

  Der Knopf steht als GESCHWISTER neben der Meldung, nicht darin: Die Meldungen
  werden per textContent gesetzt, das wuerde ein Kind jedes Mal loeschen.

  Die Texte stehen hier und nicht in drei Theme-Einstellungen. Das ist die
  bewusste Ausnahme von der Gewohnheit, Kundentexte einstellbar zu machen:
  zwei Woerter an einer Stelle sind besser als dieselben zwei Woerter an drei.
  Keine Gedankenstriche (harte Regel, Teil 5).
*/
(() => {
  if (window.__susProblemLaeuft) return;
  window.__susProblemLaeuft = true;

  const TEXT_KNOPF = 'Problem melden';
  const TEXT_DANKE = 'Danke, das ist angekommen. Wir sehen uns das an.';
  const TEXT_SCHIEF = 'Das Melden hat nicht geklappt. Schreib uns bitte eine Mail.';

  // Die Adresse des Dienstes liegt an den Blöcken, die sie ohnehin brauchen.
  // Die Adresse steht global am body (layout/theme.liquid, Einstellung
  // sus_api_basis). Die Blockattribute gelten als Rueckfall, damit der Knopf
  // auch funktioniert, wenn die globale Einstellung einmal leer ist.
  const basis = () => {
    for (const el of document.querySelectorAll('[data-sus-basis], [data-panne-basis], [data-basis]')) {
      const w = String(el.dataset.susBasis || el.dataset.panneBasis || el.dataset.basis || '').trim();
      if (w) return w.replace(/\/$/, '');
    }
    return '';
  };

  const ohneMail = (t) => String(t || '').replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '[Adresse]');

  const senden = async (meldung) => {
    const b = basis();
    if (!b) return false;
    const teile = {
      seite: location.pathname.slice(0, 80),
      meldung: ohneMail(meldung).slice(0, 200),
      geraet: '', browser: '',
    };
    // Geraet und Browser kommen aus derselben Erkennung wie die Pannenmeldung.
    try {
      if (window.susPanneGeraet) {
        teile.geraet = window.susPanneGeraet();
        teile.browser = window.susPanneBrowser();
      }
    } catch (e) { /* ohne geht es auch */ }
    const abfrage = Object.keys(teile).filter((k) => teile[k] !== '')
      .map((k) => k + '=' + encodeURIComponent(teile[k])).join('&');
    try {
      const a = await fetch(`${b}/webhook/vorschau/problem?${abfrage}`, { method: 'POST' });
      return a.ok;
    } catch (e) { return false; }
  };

  const anhaengen = (meldungEl) => {
    if (meldungEl.dataset.susProblemDa === '1') return;
    meldungEl.dataset.susProblemDa = '1';

    const kasten = document.createElement('p');
    kasten.className = 'sus-problem';
    kasten.hidden = true;
    const knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'sus-problem__knopf';
    knopf.textContent = TEXT_KNOPF;
    kasten.appendChild(knopf);
    meldungEl.insertAdjacentElement('afterend', kasten);

    knopf.addEventListener('click', async () => {
      knopf.disabled = true;
      const ok = await senden(meldungEl.textContent || '');
      kasten.textContent = ok ? TEXT_DANKE : TEXT_SCHIEF;
      kasten.classList.add(ok ? 'ist-gesendet' : 'ist-schief');
    });

    // Der Knopf erscheint genau dann, wenn die Meldung sichtbar ist.
    const nachziehen = () => {
      const sichtbar = !meldungEl.hidden && (meldungEl.textContent || '').trim() !== '';
      if (kasten.hidden === !sichtbar) return;      // nur bei Wechsel anfassen
      kasten.hidden = !sichtbar;
      if (sichtbar) {
        kasten.textContent = '';
        kasten.classList.remove('ist-gesendet', 'ist-schief');
        knopf.disabled = false;
        knopf.textContent = TEXT_KNOPF;
        kasten.appendChild(knopf);
      }
    };
    new MutationObserver(nachziehen).observe(meldungEl, {
      childList: true, characterData: true, subtree: true, attributes: true,
      attributeFilter: ['hidden'],
    });
    nachziehen();
  };

  const suchen = () => {
    document.querySelectorAll('[data-sus-fehler], [data-sus-test-fehler], [data-sus-warnung]')
      .forEach(anhaengen);
  };
  suchen();
  // Abschnitte koennen nachgeladen werden (Variantenwechsel, Warenkorb).
  new MutationObserver(suchen).observe(document.body, { childList: true, subtree: true });
})();
